<div class="topbar-content">
    <div class="page-title-group">
        <span class="eyebrow">{{ 'Admin panel' | translate }}</span>
        <h1 class="titleSize">{{ pageName | translate }}</h1>
    </div>

    <div *ngIf="userInfo != undefined" class="user-actions">
        <button (click)="openProfile()" [attr.aria-label]="'Open profile' | translate"
                [title]="'My profile' | translate"
                class="user-chip" type="button">
            <span class="avatar">{{ userInfo.Name | slice:0:1 }}</span>
            <span class="user-name">{{ userInfo.Name }}</span>
        </button>
        <label [title]="'Language' | translate" class="language-select">
            <i class="material-icons language-select-icon">language</i>
            <select (ngModelChange)="changeLanguage($event)" [attr.aria-label]="'Language' | translate"
                    [disabled]="isSavingLanguage" [ngModel]="language">
                <option value="ro">{{ 'Romanian' | translate }}</option>
                <option value="en">{{ 'English' | translate }}</option>
            </select>
            <i class="material-icons language-select-toggle">expand_more</i>
        </label>
        <button (click)="logOutClicked()" [attr.aria-label]="'Log out' | translate" [title]="'Log out' | translate"
                class="logout-button" type="button">
            <i class="material-icons">exit_to_app</i>
        </button>
    </div>
</div>
